import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";
import { downloadExport, errMsg } from "@/lib/founderApi";

const STATUS = {
  active: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  paying: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  trial: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  trialing: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  past_due: "bg-red-500/15 text-red-300 border-red-500/30",
  canceled: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  trial_ended: "bg-amber-500/15 text-amber-300 border-amber-500/30",
};

export const StatusBadge = ({ value, testid }) => (
  <span className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-semibold capitalize ${STATUS[value] || STATUS.canceled}`} data-testid={testid}>
    {String(value || "unknown").replace(/_/g, " ")}
  </span>
);

export const ChartPanel = ({ title, hint, children, testid, action }) => (
  <div className="rounded-xl border border-slate-800 bg-[#111827] p-5" data-testid={testid}>
    <div className="mb-4 flex items-start justify-between gap-3">
      <div>
        <h3 className="font-display text-sm font-bold uppercase tracking-wider text-slate-200">{title}</h3>
        {hint && <p className="mt-0.5 text-xs text-slate-500">{hint}</p>}
      </div>
      {action}
    </div>
    {children}
  </div>
);

export const tooltipStyle = { contentStyle: { background: "#0f172a", border: "1px solid #334155", borderRadius: 8, color: "#fff", fontSize: 12 }, cursor: { fill: "rgba(59,130,246,0.08)" } };

export function ExportButton({ kind, demo, label = "Export CSV" }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await downloadExport(kind, demo); } catch (e) { toast.error(errMsg(e, "Export failed.")); } finally { setBusy(false); }
  };
  return (
    <button onClick={go} disabled={busy} data-testid={`founder-export-${kind}`}
      className="inline-flex items-center gap-1.5 rounded-md border border-slate-700 bg-slate-900 px-3 py-1.5 text-xs font-semibold text-slate-200 transition-colors hover:bg-slate-800">
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Download className="h-3.5 w-3.5" />} {label}
    </button>
  );
}

export function CompanyLink({ id, name, testid }) {
  const nav = useNavigate();
  return (
    <button onClick={() => nav(`/founder/companies/${id}`)} data-testid={testid} className="text-left font-semibold text-white hover:text-blue-300 hover:underline">
      {name || id}
    </button>
  );
}

export const ErrorNote = ({ error }) => (error ? <p className="rounded-md border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-200" data-testid="founder-error">{error}</p> : null);
